import {isDigit} from '@sdox/utils'

import type {AnimatedCountProps} from './AnimatedCount'

export interface AnimatedCharProps {
  char: string
  direction: AnimatedCountProps['direction']
  isInView: boolean
  index: number
}

export const AnimatedChar = ({
  char,
  direction,
  isInView,
  index,
}: AnimatedCharProps) => {
  if (!isDigit(char)) {
    return <span>{char}</span>
  }

  // start at different zeros, based on direction
  const translateStart: string =
    direction === 'COUNT_UP' ? `translateY(0)` : `translateY(-1000%)`

  let translateEnd = `translateY(-${char}00%)`
  // if char is 0, we need to start at the other end of the digits, or the 0 would not animate at all
  if (char === '0' && direction === 'COUNT_UP') {
    translateEnd = 'translateY(-1000%)'
  }
  if (char === '0' && direction === 'COUNT_DOWN') {
    translateEnd = 'translateY(0)'
  }

  return (
    <span
      className={'flex h-lh w-ch flex-col'}
      style={{
        transition: `transform calc(1.2s + ${index} * 0.05s)`,
        transform: isInView ? translateEnd : translateStart,
      }}
    >
      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((v, index) => (
        <span
          key={index}
          className={'text-center'}
        >
          {v}
        </span>
      ))}
    </span>
  )
}
